import React from 'react';
import { Menu } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './MenuBar.css';
import NavLink from './NavLink';


const HomeMenu = ({ closeDrawer, locale, menuList, history, ...props }) => (
  <Menu mode='vertical-left' {...props} dispatch='' >
    {menuList.map(menuItem => {
      const title = menuItem.title.find(i => i.lang === locale) || "";
      if (title !== "") {
      const subItems = menuItem.items;
      subItems.sort((a,b) => {return (b.position - a.position)});
      return (
        <Menu.SubMenu key={menuItem._id} title={title.value} onTitleClick={() => history.push(title.url)} onClick={closeDrawer}>
          {subItems.map(item => {
            const itemTitle = item.title.find(i => i.lang === locale) || "";
            if (itemTitle !== "") {
            return (
              <Menu.Item key={item._id} onClick={closeDrawer}>
                <NavLink to={itemTitle.url}>
                  {itemTitle.value}
                </NavLink>
              </Menu.Item>
            )};
          })}
        </Menu.SubMenu>
      )};
    })}
  </Menu>
);

export default connect(state => ({
  locale: state.intl.locale,
  menuList: state.app.homeMenu,
}))(withRouter(HomeMenu));



// WEBPACK FOOTER //
// ./src/components/layouts/HomeMenu.js